// extracted by mini-css-extract-plugin
export var add = "_m-g";
export var bar = "_m-0";
export var brandFieldsContainer = "_m-l";
export var centered = "_m-6";
export var container = "_m-1";
export var date = "_m-f";
export var dateSpinner = "_m-i";
export var errorText = "_m-8";
export var fieldSelectionContainer = "_m-m";
export var flexOne = "_m-7";
export var icon = "_m-3";
export var iconButtonContent = "_m-5";
export var loading = "_m-2";
export var logo = "_m-4";
export var mainForm = "_m-k";
export var merchantPaidDateRange = "_m-e";
export var monospace = "_m-d";
export var section = "_m-9";
export var splitStatus = "_m-j";
export var table = "_m-a";
export var tableCell = "_m-c";
export var tableHeader = "_m-b";
export var trashIcon = "_m-h";